import environment from "src/utils/environment";
import LocalFiles from "src/modules/local-files";
import { getLibraryLullabyUrl } from "src/modules/lullaby/ajax/cloud";

async function lullabySrcResolver(lullabyId, lullaby) {
  if (!lullaby) throw new Error("Lullaby doest not exist.");
  const libraryIdentifier = lullaby.libraryIdentifier || lullaby.identifier;
  const libraryFilename = libraryIdentifier && libraryIdentifier + ".ogg";
  const isLibraryLullaby = Boolean(libraryIdentifier);

  if (environment.isBrowser && isLibraryLullaby) {
    return getLibraryLullabyUrl(libraryIdentifier);
  }
  if (environment.isBrowser) {
    return lullaby.audioFile?.url;
  }

  const filename = libraryFilename || lullaby.audioFile.name;
  if (lullabyFiles.exists(filename)) {
    return lullabyFiles.getSrc(filename);
  }

  if (isLibraryLullaby) {
    const lullabyUrl = await getLibraryLullabyUrl(libraryIdentifier);
    await lullabyFiles.download({ name: libraryFilename, url: lullabyUrl });
    return lullabyFiles.getSrc(libraryFilename);
  }

  await lullabyFiles.download(lullaby.audioFile);
  return lullabyFiles.getSrc(filename);
}

const lullabyFiles = new LocalFiles({
  srcResolver: lullabySrcResolver,
  directoryName: "lullabies"
});
export default lullabyFiles;
